import "./AllTerminals.scss";
import secondaryComponents from "../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import { useOutletContext } from "react-router-dom";
import { useEffect } from "react";

const AllTerminals = () => {
  const { setTerminalHeader } = useOutletContext();
  useEffect(() => {
    setTerminalHeader({
      title: "All Terminals",
      description:
        "All the list of terminals you have registered with Lumi Business.",
    });
  }, []);

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Terminal"
      description="List of all available terminals"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { duration: 0.3 },
          }}
          exit={{ opacity: 0 }}
        >
          <secondaryComponents.TerminalsTable />
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default AllTerminals;
